
























import { Prop, Component, Vue } from "vue-property-decorator";
import { TaskGroup } from "@/api/task-api";
import SelectOption from "@/common/ui/presenters/select-option";
import VTaskGroupControl from "@/components/task/VTaskGroupControl.vue";
import Vendor from "@/usecases/models/vendor";

@Component({
  components: {
    VTaskGroupControl
  }
})
export default class TaskGroupEditModal extends Vue {
  @Prop({ required: true }) projectId!: number;
  @Prop({ required: true }) taskGroup!: TaskGroup;
  @Prop({ default: () => [] }) vendors!: Vendor[];

  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  get vendorOptions(): SelectOption[] {
    return this.filteredVendorList.map(v => ({
      text: v.name,
      value: String(v.id)
    }));
  }

  update() {
    this.$emit("update", this.taskGroup);
    this.hide();
  }

  submit() {
    (this.$refs["submit"] as HTMLButtonElement).click();
  }

  destroy() {
    this.$emit("delete", this.taskGroup);
    this.hide();
  }

  private get filteredVendorList(): Vendor[] {
    if (!this.taskGroup) return [];
    const tid = Number(this.taskGroup.taskTypeId || 0);
    if (!tid) return this.vendors;
    return this.vendors.filter(v => v.workTypeIds.includes(tid));
  }
}
